import styled from 'styled-components';
import { CarouselItemHeader } from '../VideoCarousel/VideoCarousel.style';
import Link from '@mlb/react-patterns/v4/components/Link/link';
import COLORS from '@mlb/react-patterns/v4/style/universal.color.ts';
import Image from '@mlb/react-patterns/v4/components/Image/image';
import MediaPlaybackDiv from '@mlb/react-patterns/v4/components/MediaPlayback/mediaPlayback.style';

const {
    mlbBlack
} = COLORS;

export const VideoThumbnailWrapper = styled.div`
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  background-color: ${mlbBlack};
  border-radius: 8px;
`;

export const VideoContainerWrapper = styled.div`
  width: 100%;
  height: auto;
`;

export const VideoPlayerWrapper = styled.div`
    overflow: hidden;
    width: ${({ $width }) => $width};
    aspect-ratio: 16/9;
    border-radius: 8px;
    position: relative;
    cursor: pointer;
    background-color: ${mlbBlack};

    ${MediaPlaybackDiv} {
        position: relative;
        video,
        .media-player,
        .click-to-play-overlay {
            background-color: transparent;
            img {
                opacity: 1.0;
            }
        }

        .click-to-play-overlay .centered-play-button {
            position: absolute;
            width: 40px;
            height: 40px;
            left: 8px;
            bottom: -37%;

            svg {
                width: 40px;
                height: 40px;
            }
        }

        .play-button {
            path {
                fill: rgb(0, 0, 0);
                transform: translate(-15px,-5px) scale(1.4,1.168);
            }
            display: none;
        }
    }

`;

export const ThumbnailImage = styled(Image)`
    vertical-align: middle;
    img {
        border-radius: 8px;
    }
`;

export const ThumbnailCom = styled(Link)`
    display: inline-block;
    border-radius: 8px;
    position: relative;
    cursor: pointer;
    box-shadow: 0 0 4px 0 var(--gameday-video-carousel-shadow-color);
    width: 100%;
    height: 0;
    flex: 1;
    padding-bottom: 56.25%;
    width: ${({ $width }) => $width};
`;

export const HighlightGradient = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: var(--gameday-video-highlight-gradient);
    border-radius: 8px;
`;

export const HighlightHeader = styled(CarouselItemHeader)`
    font-family: var(--gameday-primary-font);
    width: calc(100% - 102px);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    position: relative;
    margin-left: 8px;
    margin-right: 14px;
`;

export const HighlightPlay = styled.div`
    height: 40px;
    width: 40px;
    background-color: var(--gameday-video-carousel-play-icon-color);
    border-radius: 50%;
    svg {
        margin: 10px 12px;
    }
`;

export const HighlightDuration = styled.time`
    background-color: var(--gameday-video-carousel-icon-color);
    box-sizing: border-box;
    font-family: var(--gameday-primary-font);
    font-weight: 700;
    color: var(--gameday-video-control-text-color);
    font-size: 12px;
    width: 40px;
    text-align: center;
    border-radius: 21px;
    line-height: 18px;
    height: 18px;
`;

export const HighlightControlsWrapper = styled.div`
    display: flex;
    height: 40px;
    padding: 0 8px;
    position: absolute;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    bottom: 8px;
    box-sizing: border-box;
`;
export const MetaInfoWrapper = styled.div`
    pointer-events: none; // Let click events reach the Player -> clickToPlay
`;
